/* 
  Usage:
  <ia-accordion-component class="ia-accordion {% if forloop.first %}ia-accordion--expanded{% endif %}">
    <div class="ia-accordion__header" data-toggle-accordion>
      <h3>{{ block.settings.title }}</h3>
      <span class="ia-accordion__expand-icon iconic-button">
        {{ 'icon-plus.svg' | inline_asset_content }}
        {{ 'icon-minus.svg' | inline_asset_content }}
      </span>
    </div>
    <div class="ia-accordion__body">
      <div class="ia-accordion__content">
        {{ block.settings.answer }}
      </div>
    </div>
  </ia-accordion-component>
*/

if (!customElements.get('ia-accordion-component')) {
  class IaAccordionComponent extends HTMLElement {
    constructor () {
      super()
      this.body = this.querySelector('.ia-accordion__body')
      this.querySelector('[data-toggle-accordion]').addEventListener('click', this.toggleAccordion.bind(this))
    }

    connectedCallback () {

    }

    toggleAccordion () {
      const group = this.closest('[data-accordion-group]') || this.parentElement
      const accordionItems = group.querySelectorAll('ia-accordion-component')

      if (!this.classList.contains('ia-accordion--expanded')) {
        accordionItems.forEach(accordion => {
          accordion.close()
        })
        this.open()
      } else {
        this.close()
      }
    }

    open () {
      this.classList.add('ia-accordion--expanded')
      this.body.style.maxHeight = `${this.body.scrollHeight}px`
    }

    close () {
      this.classList.remove('ia-accordion--expanded')
      this.body.style.maxHeight = '0px'
    }
  }

  customElements.define('ia-accordion-component', IaAccordionComponent)
} 